import { render, staticRenderFns } from "./ArticleListPage.vue?vue&type=template&id=66693caa&scoped=true"
import script from "./ArticleListPage.vue?vue&type=script&lang=js"
export * from "./ArticleListPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleListPage.vue?vue&type=style&index=0&id=66693caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66693caa",
  null
  
)

export default component.exports